import { ProtectedSidebarLink, ProtectedSidebarLinkGroup } from '@britishcouncil/react-admin';
import { useLocation } from 'react-router';

import { ROUTING_PATHS } from 'const';

export const BulkActionsSidebar = () => {
  const { pathname } = useLocation();
  const {
    bulkActions: {
      path: basePath,
      requiresAny,
      trainingAndStandardisationSessions,
      speakingMonitorings,
      osmMonitoringResults,
      osmMonitoringArchiving,
      examinerRoles,
      examinerContactDetails,
      examinerCentres,
      speakingCertifications,
      writingCertifications,
      odpAssessments,
      odpMonitorings,
    },
  } = ROUTING_PATHS;

  return (
    <>
      <ProtectedSidebarLinkGroup
        requiresAny={requiresAny}
        name="Bulk Actions"
        icon="cloud download"
        expanded={pathname.startsWith(basePath)}
      >
        <ProtectedSidebarLink
          {...trainingAndStandardisationSessions}
          name="Training and standardisation sessions"
          icon="file outline"
        />
        <ProtectedSidebarLink {...odpAssessments} name="ODP assessments" icon="file outline" />
        <ProtectedSidebarLink
          {...speakingMonitorings}
          name="Speaking monitoring"
          icon="file outline"
        />
        <ProtectedSidebarLink {...odpMonitorings} name="ODP monitoring" icon="file outline" />
        <ProtectedSidebarLink
          {...osmMonitoringResults}
          name="OSM monitoring results"
          icon="file outline"
        />
        <ProtectedSidebarLink
          {...osmMonitoringArchiving}
          name="OSM monitoring archiving"
          icon="file outline"
        />
        <ProtectedSidebarLink {...examinerRoles} name="Examiner roles" icon="file outline" />
        <ProtectedSidebarLink
          {...examinerContactDetails}
          name="Examiner contact details"
          icon="file outline"
        />
        <ProtectedSidebarLink {...examinerCentres} name="Examiner centres" icon="file outline" />
        <ProtectedSidebarLink
          {...speakingCertifications}
          name="Speaking certifications"
          icon="file outline"
        />
        <ProtectedSidebarLink
          {...writingCertifications}
          name="Writing certifications"
          icon="file outline"
        />
      </ProtectedSidebarLinkGroup>
    </>
  );
};
